module.exports = __webpack_public_path__ + "static/assets/797f67a4b26b2700e1894dbf6f2af7f8.svg";